export default __webpack_public_path__ + "img/69833662b864cdb3de2e783450696504.png";